import React from 'react';
import { GeetaDaraClass82025 } from '../views';

const AccountGeneralPage = () => {
  return <GeetaDaraClass82025 />;
};

export default AccountGeneralPage;